import { setPreventUnload } from 'flow/actions/app-actions';
import React, { ReactNode } from 'react';

interface MailToWrapperProps {
    children: ReactNode;
    recipient?: string;
    subject?: string;
    body?: string;
    onClickSideEffect?: () => void;
    className?: string;
    ariaLabel?: string;
}

const MailToWrapper: React.FC<MailToWrapperProps> = ({
    children,
    recipient = '',
    subject = '',
    body = '',
    onClickSideEffect,
    className,
    ariaLabel,
}) => {
    const handleClick = () => {
        setPreventUnload(true);
        if (onClickSideEffect) {
            onClickSideEffect();
        }
    };

    const parameters = [
        ...(subject ? [`subject=${encodeURIComponent(subject)}`] : []),
        ...(body ? [`body=${encodeURIComponent(body)}`] : []),
    ];

    const joinedParameters = parameters.join('&');

    const mailToString =
        'mailto:' +
        recipient +
        (parameters.length !== 0 ? '?' + joinedParameters : '');

    return (
        <a
            href={mailToString}
            onClick={handleClick}
            className={className}
            aria-label={ariaLabel}
        >
            {children}
        </a>
    );
};

export default MailToWrapper;
